export default "__VITE_ASSET__2d114fe9__"